// extracted by mini-css-extract-plugin
export default {"btnBlock":"NewPassword_btnBlock__hyCZI","forgotBtn":"NewPassword_forgotBtn__1CZdZ"};